var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M8.005 2.85A2 2 0 0 1 10 1h4a2 2 0 0 1 2 2v2H8V3zM19 3a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h1v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }